import { LotsManagementEditVM } from 'front-office/view-models/lots-management/edit';
import { LotsManagementNewVM } from 'front-office/view-models/lots-management/new';
import * as yup from 'yup';

export const validationSchemaFilter = yup.object().shape({
  filter: yup
    .object()
    .nullable()
    .shape({
      dateFrom: yup.date().nullable().required('Campo obbligatorio').typeError('Data non valida'),
      dateTo: yup
        .date()
        .nullable()
        .required('Campo obbligatorio')
        .typeError('Data non valida')
        .when('dateFrom', (dateFrom, formvalidationSchema) =>
          dateFrom && dateFrom?.toString() !== 'Invalid Date'
            ? formvalidationSchema.min(
                dateFrom,
                'La data deve essere maggiore o uguale della data dal'
              )
            : formvalidationSchema.nullable()
        ),
    }),
});

const numberRegex = /^([A-Za-z]{2}[0-9]{7})$/;

export const validationSchemaNew = yup
  .object()
  .shape({
    fromNumber: yup
      .string()
      .nullable()
      .required('Il campo è obbligatorio')
      .matches(numberRegex, 'Formato non valido'),
    toNumber: yup
      .string()
      .nullable()
      .required('Il campo è obbligatorio')
      .matches(numberRegex, 'Formato non valido'),
  })
  .test('toNumber', 'Controlli', (values) => {
    const castedValues = values as unknown as LotsManagementNewVM;

    const fromNumberLengthCorrect = (castedValues.fromNumber?.length || 0) === 9;

    const toNumberLengthCorrect = (castedValues.toNumber?.length || 0) === 9;

    const fromNumber = castedValues?.fromNumber || '';

    const toNumber = castedValues?.toNumber || '';

    if (!fromNumberLengthCorrect || !toNumberLengthCorrect) {
      // lunghezza ko, controllo sopra in regex
      return true;
    }

    if (fromNumber[0] !== toNumber[0] || fromNumber[1] !== toNumber[1]) {
      return new yup.ValidationError(
        'Il prefisso dei numeri deve essere uguale',
        undefined,
        'toNumber'
      );
    }

    if (fromNumber[0] !== toNumber[0] || fromNumber[1] !== toNumber[1]) {
      return new yup.ValidationError(
        'Il prefisso dei numeri deve essere uguale',
        undefined,
        'toNumber'
      );
    }

    const fromNumberFormattedInt = Number.parseInt(fromNumber.substring(2), 10);

    const toNumberFormattedInt = Number.parseInt(toNumber.substring(2), 10);

    if (fromNumberFormattedInt > toNumberFormattedInt) {
      return new yup.ValidationError('Numero da è maggiore di numero a', undefined, 'toNumber');
    }

    const diff = toNumberFormattedInt - fromNumberFormattedInt;

    if (diff > 100) {
      return new yup.ValidationError(
        'La differenza tra numero da e numero a deve essere minore uguale di 100',
        undefined,
        'toNumber'
      );
    }

    if (fromNumber.substring(2, 5) !== toNumber.substring(2, 5)) {
      return new yup.ValidationError(
        'I primi tre numeri devono essere uguali',
        undefined,
        'toNumber'
      );
    }

    return true;
  });

export const validationSchemaEdit = yup
  .object()
  .shape({
    fromNumber: yup
      .string()
      .nullable()
      .required('Il campo è obbligatorio')
      .matches(numberRegex, 'Formato non valido'),
    toNumber: yup
      .string()
      .nullable()
      .required('Il campo è obbligatorio')
      .matches(numberRegex, 'Formato non valido'),
    released: yup.number().nullable(),
  })
  .test('toNumber', 'Controlli', (values) => {
    const castedValues = values as unknown as LotsManagementNewVM;

    const fromNumberLengthCorrect = (castedValues.fromNumber?.length || 0) === 9;

    const toNumberLengthCorrect = (castedValues.toNumber?.length || 0) === 9;

    const fromNumber = castedValues?.fromNumber || '';

    const toNumber = castedValues?.toNumber || '';

    if (!fromNumberLengthCorrect || !toNumberLengthCorrect) {
      // lunghezza ko, controllo sopra in regex
      return true;
    }

    if (fromNumber[0] !== toNumber[0] || fromNumber[1] !== toNumber[1]) {
      return new yup.ValidationError(
        'Il prefisso dei numeri deve essere uguale',
        undefined,
        'toNumber'
      );
    }

    if (fromNumber[0] !== toNumber[0] || fromNumber[1] !== toNumber[1]) {
      return new yup.ValidationError(
        'Il prefisso dei numeri deve essere uguale',
        undefined,
        'toNumber'
      );
    }

    const fromNumberFormattedInt = Number.parseInt(fromNumber.substring(2), 10);

    const toNumberFormattedInt = Number.parseInt(toNumber.substring(2), 10);

    if (fromNumberFormattedInt > toNumberFormattedInt) {
      return new yup.ValidationError('Numero da è maggiore di numero a', undefined, 'toNumber');
    }

    const diff = toNumberFormattedInt - fromNumberFormattedInt;

    if (diff > 100) {
      return new yup.ValidationError(
        'La differenza tra numero da e numero a deve essere minore uguale di 100',
        undefined,
        'toNumber'
      );
    }

    if (fromNumber.substring(2, 5) !== toNumber.substring(2, 5)) {
      return new yup.ValidationError(
        'I primi tre numeri devono essere uguali',
        undefined,
        'toNumber'
      );
    }

    return true;
  })
  .test('released', 'Controllo', (values) => {
    const castedValues = values as unknown as LotsManagementEditVM;

    const fromNumberLengthCorrect = (castedValues.fromNumber?.length || 0) === 9;

    const toNumberLengthCorrect = (castedValues.toNumber?.length || 0) === 9;

    const fromNumber = castedValues?.fromNumber || '';

    const toNumber = castedValues?.toNumber || '';

    if (!fromNumberLengthCorrect || !toNumberLengthCorrect) {
      // lunghezza ko, controllo sopra in regex
      return true;
    }

    const fromNumberFormattedInt = Number.parseInt(fromNumber.substring(2), 10);

    const toNumberFormattedInt = Number.parseInt(toNumber.substring(2), 10);

    const diff = toNumberFormattedInt - fromNumberFormattedInt + 1;

    if ((castedValues.released || 0) > diff) {
      return new yup.ValidationError(
        'Il campo non può essere superiore al numero totale carte del Lotto',
        undefined,
        'released'
      );
    }

    return true;
  });
